import { ContactData } from '@/types/index'

const createEmptyContactData = (): ContactData => {
  return {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    phoneMobile: ''
  }
}

export { createEmptyContactData }
